module.exports = __webpack_public_path__ + "static/media/mh.c8caa175.png";